'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdRedo = function MdRedo(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm30.7 17.7l5.9-6.1v15h-15l6.1-6c-2.3-1.9-5.3-3.1-8.6-3.1-5.9 0-10.9 3.8-12.6 9.1l-3.9-1.2c2.2-7 8.8-12 16.5-12 4.5 0 8.6 1.6 11.6 4.3z' })
        )
    );
};

exports.default = MdRedo;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/redo.js
// module id = 1377
// module chunks = 36573943044255 79611799117203 213534597649335